import React, { useContext, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import {
  FlexBox,
  SpacingBox,
  LanguagePicker,
  GoBackRouteButton,
} from '../Components';
import TopMenu from './TopMenu';
import GenrePicker from './GenrePicker';
import CurrentOrderInfo from './CurrentOrderInfo';
import { firstScreen, lowaCustomerSelect, routes } from '../routes';
import PriceTypePicker from './PriceTypePicker';
import AppContext from '../AppContext';
import { getTranslateByScope } from '../i18n';
import StatusNotifications from './StatusNotifications';
import SchLogoImg from "../assets/Logo.png";
import DootImg from "../assets/doot.png";

const sch_lowa_logo = "https://assets-crm.schoeffel.de/public/images/assets/sch-lowa.png"
const translations = getTranslateByScope('topbar');

const Logo = (props) => <img alt="logo" width="170px" src={props.url} />;

export const Topbar = (props) => {
  const { pathname } = props.location;
  const isFirstScreen = pathname === firstScreen || pathname === routes.orderCustomerSelection;
  const isLowaSelect = pathname === lowaCustomerSelect || pathname === routes.lowaCustomerSelect;
  const showLanguagePicker = isFirstScreen || isLowaSelect

  const context = useContext(AppContext);
  const menuAnchorRef = useRef(null);
  const marketing = !!context.state.marketing;

  const lowa = context.state.lowa;
  const lowaCustomer = context.state.lowaCustomer || {};
  const gotoLowaSelect = () => {
    props.history.push('/lowaSelect');
  };

  let logoUrl = SchLogoImg;
  if (lowa) {
    logoUrl = sch_lowa_logo;
  }

  const hasLowaCustomer = lowaCustomer != null && Object.keys(lowaCustomer).length > 0;

  return (
    <div className="container-fluid">
      { !marketing && <StatusNotifications />}
        <div style={{marginTop: '100px'}}>

        <FlexBox flex={1} justifyContent="center" alignItems="center">
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => props.history.push(routes.landingPage)}>
            <Logo url={logoUrl} />
          </div>
        </FlexBox>

        <div style={{paddingTop: '10px', paddingBottom: '10px'}}>
          <div style={{position: 'absolute', marginTop: '5px', maxWidth: '100%', marginBottom: '5px', left: '0', width: '100vw', height: '16px', backgroundImage: `url(${DootImg})`, backgroundSize: 'contain', backgroundRepeat: 'repeat'}}></div>
        </div>

        <SpacingBox marginTop="md">
          <div ref={menuAnchorRef}>
          <FlexBox flex="0 1 0" alignItems="center" justifyContent="space-between">
            <FlexBox flex={1} justifyContent="flex-start" alignItems="center" flexGrow={1}>
              { !marketing && <GenrePicker anchorRef={menuAnchorRef} /> }
              {isFirstScreen && (
                <>
                  { marketing && <GoBackRouteButton text="Go Back" marketing="true" /> }
                </>
              )}
              <SpacingBox marginLeft="lg">
                { !marketing && <PriceTypePicker /> }
              </SpacingBox>
            </FlexBox>


            <FlexBox
              flex="1 1 0"
              flexGrow={1}
              justifyContent="center"
              flexDirection="column"
              alignItems="center">
                {showLanguagePicker && <LanguagePicker/>}
                <div style={{width: '100%', textAlign: 'center'}}>
                {!isLowaSelect && (
                  <>
                  {lowa && !hasLowaCustomer && (
                    <span style={{cursor: 'pointer', color: 'red', fontWeight: 'bold'}} onClick={gotoLowaSelect}>
                      {translations('enter_customerno')}
                    </span>
                  )}
                  {lowa && hasLowaCustomer && (
                    <span style={{fontWeight: 'bold'}}>
                      {lowaCustomer.Name} - {lowaCustomer.BillingCity}
                    </span>
                  )}
                  </>
                )}
                </div>
                {<CurrentOrderInfo />}
            </FlexBox>


            <FlexBox flex="0 1 0" justifyContent="flex-end" alignItems="center" flexGrow={1}>
              <TopMenu marketing={marketing} anchorRef={menuAnchorRef} />
            </FlexBox>
          </FlexBox>
          </div>
         </SpacingBox>
      </div>
    </div>
  );
};

export default withRouter(Topbar);
